// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorView_wrapper__5ne6b","body":"ErrorView_body__+iMZ9","title":"ErrorView_title__DgvnS","subtitle":"ErrorView_subtitle__rFS+9","email":"ErrorView_email__tEH2V"};